import axios from "axios";

const apiMiddleware = axios.create({
  baseURL: process.env.REACT_APP_BOVEXO_MIDDLEWARE_URL,
  validateStatus: (status) => status >= 200 && status < 300,
  // baseURL: "http://localhost:8085",
});

export default apiMiddleware;
